import React, { useState } from "react";
import { toast } from "sonner";
import { PageTitle, Panel, Field, TextInput, Btn } from "../components/ui";
import { CL, tokenStore, pwValid } from "../api";
import { useAuth } from "../auth";
import { useI18n } from "../i18n";

export default function Profile() {
  const { user } = useAuth();
  const { t } = useI18n();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!current || !next) return toast.error(t("pwErrFillAll"));
    if (!pwValid(next)) return toast.error(t("pwRule"));
    if (next !== confirm) return toast.error(t("pwErrMismatch"));
    setBusy(true);
    try {
      const res = await CL.changePassword(current, next);
      if (res.token) tokenStore.set(res.token);
      toast.success(t("pwSavedOthers"));
      setCurrent(""); setNext(""); setConfirm("");
    } catch (e) {
      toast.error(e?.response?.data?.detail || t("pwErrCurrent"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="profile-page">
      <PageTitle title={t("profileTitle")} subtitle={t("profileDesc")} />

      <Panel>
        <div className="grid gap-4 md:grid-cols-2">
          <div>
            <div className="text-xs uppercase tracking-widest text-[#8a8f83]">{t("name")}</div>
            <div className="text-[15px] text-[#1b2420]" data-testid="profile-name">{user?.name || "—"}</div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-[#8a8f83]">{t("authEmail")}</div>
            <div className="text-[15px] text-[#1b2420]" data-testid="profile-email">{user?.email}</div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-[#8a8f83]">{t("profileRole")}</div>
            <div className="text-[15px] text-[#1b2420]" data-testid="profile-role">{user?.role}</div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-[#8a8f83]">{t("profileOrgLabel")}</div>
            <div className="text-[15px] text-[#1b2420]" data-testid="profile-org">{user?.org_name || "—"}</div>
          </div>
        </div>
      </Panel>

      <div className="h-4" />

      <Panel>
        <div className="mb-4 font-display text-lg text-[#14512f]">{t("changePasswordTitle")}</div>
        <div className="grid gap-4 md:max-w-md">
          <Field label={t("pwCurrent")}>
            <TextInput data-testid="pw-current" type="password" value={current}
                       onChange={(e) => setCurrent(e.target.value)} autoComplete="current-password" />
          </Field>
          <Field label={t("pwNew")}>
            <TextInput data-testid="pw-new" type="password" value={next}
                       onChange={(e) => setNext(e.target.value)} autoComplete="new-password" />
          </Field>
          <Field label={t("pwConfirm")}>
            <TextInput data-testid="pw-confirm" type="password" value={confirm}
                       onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" />
          </Field>
          <div>
            <Btn onClick={submit} disabled={busy} data-testid="pw-save">{t("pwUpdate")}</Btn>
          </div>
        </div>
      </Panel>
    </div>
  );
}
